import React, { useState } from "react";
import { VStack, Box, Image, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton } from "@chakra-ui/react";
import Section from "./Section";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";
import { getAssetLanguageKey } from "../i18n/language";

const Tutorial: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedTitle, setSelectedTitle] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const totalImages = 18;
  const languageSuffix = getAssetLanguageKey(
    i18n.resolvedLanguage || i18n.language,
  ) === "zh" ? "zh_hk" : "en";
  const tutorials = Array.from({ length: totalImages }, (_, i) => {
    const imageNumber = String(i + 1).padStart(2, "0");
    const tutorial = `https://assets.deepsoulai.com/tutorial/tutorial_${imageNumber}_${languageSuffix}.png`;
    return [tutorial, t(`tutorial.preview${i + 1}`)];
  });

  const openModal = (image: string, title: string) => {
    setSelectedImage(image);
    setSelectedTitle(title);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedImage(null);
    setSelectedTitle(null);
  };

  return (
    <>
      <SEO 
        title={t("seo.pages.tutorial.title")}
        description={t("seo.pages.tutorial.description")}
        keywords={t("seo.pages.tutorial.keywords")}
        canonical="https://deepsoulai.com/tutorial"
      />
      <Section title={t("tutorial.title")} maxW="1400px">
      <VStack align="start" spacing={8}>
        <Box display="grid" gridTemplateColumns={{ base: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }} gap={4}>
          {tutorials.map(([tutorial, title], index) => (
            <Image
              key={index}
              src={tutorial}
              alt={`Tutorial ${index + 1}`}
              borderRadius="md"
              boxShadow="md"
              cursor="pointer"
              onClick={() => openModal(tutorial, title)}
              draggable={false}
            />
          ))}
        </Box>
      </VStack>

      {/* Modal for Image Preview */}
      <Modal isOpen={isOpen} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent
          maxW={{ base: "90vw", md: "800px" }} // 設置最大寬度為 800px
          maxH="90vh"
          width="auto"
          mx="auto"
          my="auto"
        >
          <ModalHeader>{selectedTitle || "previewTitle"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow="auto" p={2}>
            {selectedImage && (
              <Image
                src={selectedImage}
                alt={selectedTitle || "previewImage"}
                maxW="100%"
                maxH="70vh"
                mx="auto"
                objectFit="contain"
                draggable={false}
                onDragStart={(e) => e.preventDefault()}
                style={{ userSelect: "none" }}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Section>
    </>
  );
};

export default Tutorial;
